import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { getErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { NeonButton, NeonCard } from "../components/Neon";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate(location.state?.from || "/");
    } catch (err) {
      toast.error(getErr(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <NeonCard variant="flow" innerClassName="p-8">
        <h1 className="font-display uppercase text-4xl text-white glow-white">Log In</h1>
        <p className="mt-1 text-sm text-[var(--text-muted)]">Welcome back to Richie Rich Competitions.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-[var(--text-muted)]">Email</label>
            <input data-testid="login-email" type="email" autoComplete="username" spellCheck="false" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-[var(--surface-2)] border border-white/10 rounded-xl px-3 py-2.5 text-white focus:outline-none focus:border-[var(--neon-cyan)]" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label className="text-xs uppercase tracking-widest text-[var(--text-muted)]">Password</label>
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-[var(--neon-cyan)] hover:underline">Forgot password?</Link>
            </div>
            <input data-testid="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-[var(--surface-2)] border border-white/10 rounded-xl px-3 py-2.5 text-white focus:outline-none focus:border-[var(--neon-cyan)]" />
          </div>
          <NeonButton type="submit" variant="pink" className="w-full" data-testid="login-submit" loading={loading}>Log In</NeonButton>
        </form>
        <p className="mt-5 text-sm text-[var(--text-muted)]">New here? <Link to="/register" className="text-[var(--neon-pink)] hover:underline">Create an account</Link></p>
      </NeonCard>
    </div>
  );
}
